import { render, staticRenderFns } from "./matchContact.vue?vue&type=template&id=de379dd6"
import script from "./matchContact.vue?vue&type=script&lang=js"
export * from "./matchContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports